import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCr9i3qiX2t2YLcvm-0Hmyku-nf8Z6-I9c",
  authDomain: "fir-b70c3.firebaseapp.com",
  projectId: "fir-b70c3",
  storageBucket: "fir-b70c3.appspot.com",
  messagingSenderId: "620972098363",
  appId: "1:620972098363:web:75c4e49d270bc63c5fed1e",
  measurementId: "G-MBM1H9CSL1"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth }; 